import { AssessmentScopeIntegration } from "@p0security/shared/types/assessment";
import { noop } from "lodash";
import { createContext, useMemo, useState } from "react";

import { TargetInput } from "../components/TargetSelect";

export const EnvironmentCreationContext = createContext<{
  currentIntegration: AssessmentScopeIntegration | undefined;
  formInputs: TargetInput;
  setFormInputs: React.Dispatch<React.SetStateAction<TargetInput>>;
  setCurrentIntegration: React.Dispatch<
    React.SetStateAction<AssessmentScopeIntegration | undefined>
  >;
}>({
  currentIntegration: undefined,
  formInputs: { targets: { scopes: [], subtractiveScopes: [] } },
  setFormInputs: noop,
  setCurrentIntegration: noop,
});

export const EnvironmentCreationProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [currentIntegration, setCurrentIntegration] =
    useState<AssessmentScopeIntegration>();
  const [formInputs, setFormInputs] = useState<TargetInput>({
    targets: { scopes: [], subtractiveScopes: [] },
  });

  const value = useMemo(
    () => ({
      currentIntegration,
      formInputs,
      setFormInputs,
      setCurrentIntegration,
    }),
    [currentIntegration, formInputs]
  );

  return (
    <EnvironmentCreationContext.Provider value={value}>
      {children}
    </EnvironmentCreationContext.Provider>
  );
};
